// extracted by mini-css-extract-plugin
export default {"tabContainer":"score_tabContainer__q8Yq5","tabs":"score_tabs__zpmzj","tabItem":"score_tabItem__Gqmj4"};